<template>
	<div>
		<div v-if="finishUid" class="flex-row flex-align-center">
			<slot />
			<el-popover @show="handleInit" v-if="edit && $isSp()" width="356" placement="top-start" trigger="click" v-model="visible">
				<div class="p-16">
					<div class="color-gy-9 fz-14 mb-12">修改视频号ID</div>
					<div class="flex-row flex-row-align-center mb-20">
						<div style="width: 80px" class="fz-14 color-gy-8">视频号ID</div>
						<el-input v-model="value" placeholder="请输入" />
					</div>
					<div class="text-align-right">
						<el-button @click="visible = false">取消</el-button>
						<el-button type="primary" @click="handleSave">确认</el-button>
					</div>
				</div>
				<i slot="reference" class="el-icon-edit-outline cursor-pointer"></i>
			</el-popover>
		</div>
		<template v-else>
			<div v-if="isView" class="fz-12 color-o-4">
				<i class="el-icon-warning fz-14"></i>
				{{ viewText }}
			</div>
			<div v-else class="spVerify">
				<el-popover @show="handleInit" width="356" placement="top-start" trigger="click" v-model="visible">
					<div class="p-16">
						<div v-if="nofilled" class="color-gy-9 fz-14 mb-12">请填写视频ID</div>
						<div v-if="unverified">
							<div class="color-gy-9 fz-14 mb-12">视频号ID待校准</div>
							<div class="fz-12 color-gy-7 mb-12">视频号ID影响业绩归属，请确认所填信息是否准确?</div>
						</div>
						<div class="flex-row flex-row-align-center mb-20">
							<div style="width: 80px" class="fz-14 color-gy-8">视频号ID</div>
							<el-input v-model="value" :placeholder="unverified ? '请校准' : '请及时补充避免影响业绩'" />
						</div>
						<div class="text-align-right">
							<el-button @click="visible = false">取消</el-button>
							<el-button v-if="nofilled" type="primary" :disabled="!value" @click="handleSave">确认</el-button>
							<el-button v-if="unverified" type="primary" @click="handleVerify">确认无误</el-button>
						</div>
					</div>
					<div slot="reference" class="fz-12 color-o-4 cursor-pointer">
						<i class="el-icon-warning fz-14"></i>
						{{ viewText }}
						<i class="el-icon-arrow-right"></i>
					</div>
				</el-popover>
			</div>
		</template>
	</div>
</template>

<script>
import { editSphAnchor } from '@/api/talentCRM';
export default {
	props: {
		// 2 正常 战场插槽， 1待校验状态，0未填写
		type: {
			type: [Number, String],
			default: 2,
		},
		// 开启编辑 默认不开启
		// 仅在type = 1 时生效
		edit: {
			type: Boolean,
			default: false,
		},
		// 仅展示
		isView: {
			type: Boolean,
			default: false,
		},
		// 用于控制不是 仅展示 确显示仅展示的文案
		callView: {
			type: Boolean,
			default: false,
		},

		platformId: {
			type: [String, Number],
			default: dataMap.PLATFORM_SP.value,
		},
		anchoId: {
			type: [String, Number],
		},
		anchorUid: {
			type: [String, Number],
		},
	},
	data() {
		return {
			value: '',
			visible: false,
		};
	},
	methods: {
		async handleSave() {
			const { code, data } = await editSphAnchor({
				anchorId: this.anchoId,
				videoNo: this.value,
			});
			if (code !== 0) return;
			this.visible = false;
			this.$emit('refresh', data);
			this.$message.success('操作成功!');
		},
		async handleVerify() {
			const { code, data } = await editSphAnchor({
				anchorId: this.anchoId,
				videoNo: this.value,
			});
			if (code !== 0) return;
			this.visible = false;
			this.$message.success('操作成功!');
			this.$emit('refresh', data);
		},
		handleInit() {
			this.value = '';
			if (this.unverified) {
				this.value = this.anchorUid;
			}
		},
	},
	computed: {
		// 语义化一些， 分出来 正常 待校验 和待填写
		viewText() {
			const textType = this.isView || this.callView ? 2 : 1;
			const visible = {
				1: '视频号ID待校准',
				2: '待校准',
			};
			const fillIn = {
				1: '填写视频号ID',
				2: '请及时补充避免影响业绩',
			};
			return this.unverified ? visible[textType] : fillIn[textType];
		},
		finishUid() {
			// 完成的 没毛病的
			return this.type == 2;
		},
		unverified() {
			// 待校验的
			return this.type == 1;
		},
		nofilled() {
			// 未填写的
			return this.type == 0;
		},
	},
};
</script>

<style lang="less" scoped>
.spVerify {
	overflow: hidden;
	display: flex;
	align-content: center;
	line-height: 20px !important;
}
</style>
